import { Box } from "@mui/material";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Table from "../../components/table/Table";
import HomeLayout from "../../layouts/Home";

const HospitalConfig = () => {
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
    length: 0,
    hidden: false,
  });

  const rows = [];

  return (
    <HomeLayout {...{ title: "Configuration" }}>
      <SearchBar placeholder="Search For Service..." />
      <Box
        className="pt-8 px-8 mt-5 bg-[var(--c-bg-color)] rounded-lg w-100%"
        sx={{ p: 0 }}
      >
        <Table
          {...{
            dropdownMenu: rows,
            data: rows,
            pagination,
            setPagination,
          }}
        />
      </Box>
    </HomeLayout>
  );
};

export default HospitalConfig;
